var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "col-12 pr-0 flex rating" }, [
        _c("div", { staticClass: "col-2 rating-grade" }, [
          _c("span", { staticClass: "rating-avg" }, [
            _vm._v("\n        " + _vm._s(_vm.ratings[0].rating) + "\n      ")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "text-uppercase rating-sub" }, [
            _vm._v("\n        out of 5\n      ")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-4 flex star-ratings" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-column" },
            [
              _c("star-rating", {
                staticStyle: { "line-height": "0" },
                attrs: {
                  rating: _vm.ratings[0].value,
                  "star-size": 15,
                  "show-rating": false,
                  increment: 0.1,
                  "read-only": true
                }
              }),
              _vm._v(" "),
              _c("star-rating", {
                attrs: {
                  rating: _vm.ratings[0].communication,
                  "star-size": 15,
                  "show-rating": false,
                  increment: 0.1,
                  "read-only": true
                }
              }),
              _vm._v(" "),
              _c("star-rating", {
                attrs: {
                  rating: _vm.ratings[0].punctuality,
                  "star-size": 15,
                  "show-rating": false,
                  increment: 0.1,
                  "read-only": true
                }
              }),
              _vm._v(" "),
              _c("star-rating", {
                attrs: {
                  rating: _vm.ratings[0].commitment,
                  "star-size": 15,
                  "show-rating": false,
                  increment: 0.1,
                  "read-only": true
                }
              }),
              _vm._v(" "),
              _c("star-rating", {
                attrs: {
                  rating: _vm.ratings[0].customer_service,
                  "star-size": 15,
                  "show-rating": false,
                  increment: 0.1,
                  "read-only": true
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-6 flex pt-3" },
          [
            _c("div", { staticClass: "rating-grade-wrap col-6" }, [
              _c(
                "p",
                { staticClass: "customer-review" },
                [
                  _vm.ratings[0].body
                    ? _c("read-more", {
                        attrs: {
                          "more-str": "Show more",
                          text: _vm.ratings[0].body,
                          "less-str": "Show less",
                          "max-chars": 300
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            !_vm.ratings[0].reply &&
            !_vm.ratings[0].reply_at &&
            _vm.$_can("companies.ratings.update-reply")
              ? [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-6 flex justify-content-end align-items-start"
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          on: {
                            click: function($event) {
                              _vm.showReply = true
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            Reply to Customer Review\n          "
                          )
                        ]
                      )
                    ]
                  )
                ]
              : [
                  _c("div", { staticClass: "col-6" }, [
                    _c("h5", { staticClass: "text-secondary" }, [
                      _vm._v("Company response:")
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "customer-review text-break" },
                      [
                        _vm.ratings[0].reply
                          ? _c("read-more", {
                              attrs: {
                                "more-str": "Show more",
                                text: _vm.ratings[0].reply,
                                "less-str": "Show less",
                                "max-chars": 300
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm.showReply
        ? _c("company-rating-reply-modal", {
            attrs: { rating: _vm.ratings[0] },
            on: { close: _vm.closeReply }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-column" }, [
      _c("span", { staticClass: "rating-heading" }, [_vm._v("Service value")]),
      _vm._v(" "),
      _c("span", { staticClass: "rating-heading" }, [_vm._v("Communication")]),
      _vm._v(" "),
      _c("span", { staticClass: "rating-heading" }, [_vm._v("Punctuality")]),
      _vm._v(" "),
      _c("span", { staticClass: "rating-heading" }, [
        _vm._v("Mover commitment")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "rating-heading" }, [
        _vm._v("Customer service")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7562429e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7562429e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobRating.vue
// module id = null
// module chunks = 